
define(["jquery"], function($) {
    var meetingDocuments = {

        document: $("#meeting-documents > #protocols > .meeting-documents-list > li"),
        documentErrand: $("#meeting-contents > #errends > .meeting-documents-list > li"),
        documentState: false,
        errandState: false,

        init: function () {
            $(".expand-box").hide();
            $(".js-meeting-document-expand-link").attr("aria-expanded", "false");
            $(".meeting-documents-list > li").find(".expand-box").attr("aria-hidden", "true");

            $(".js-meeting-document-expand-link").click(function (e) {
                e.preventDefault();
                $(this).parents("li").find(".expand-box").css("display") === "none" ?
                    $(this).parents("li").removeClass("closed").addClass("open") : 
                    $(this).parents("li").removeClass("open").addClass("closed");
                $(this).parents("li").find(".expand-box").toggle();

                //Aria attributes
                $(this).parents("li").find(".expand-box").css("display") === "none" ?
                    $(this).attr("aria-expanded", "false") :
                    $(this).attr("aria-expanded", "true");
                $(this).parents("li").find(".expand-box").css("display") === "none" ?
                    $(this).parents("li").find(".expand-box").attr("aria-hidden", "true") :
                    $(this).parents("li").find(".expand-box").attr("aria-hidden", "false");
            });
            $("#document-protocol").click(function (e) {
                e.preventDefault();
                meetingDocuments.documentState = !meetingDocuments.documentState;
                meetingDocuments.documentState === true ? meetingDocuments.open(meetingDocuments.document, "#document-protocol") :
                meetingDocuments.close(meetingDocuments.document, "#document-protocol");
            });
            $("#document-errands").click(function (e) {
                e.preventDefault();
                meetingDocuments.errandState = !meetingDocuments.errandState;
                meetingDocuments.errandState === true ? meetingDocuments.open(meetingDocuments.documentErrand, "#document-errands") :
                meetingDocuments.close(meetingDocuments.documentErrand, "#document-errands");
            });
            
        },
        close: function (selector, id) {
            $(selector).find(".expand-box").css("display", "none");
            $(selector).removeClass("open").addClass("closed");
            $(id).text("Öppna alla");
            //Aria
            $(selector).find(".js-meeting-document-expand-link").attr("aria-expanded", "false");
            $(selector).find(".expand-box").attr("aria-hidden", "true");
        },
        open: function (selector, id) {
            $(selector).find(".expand-box").css("display", "block");
            $(selector).removeClass("closed").addClass("open");
            $(id).text("Stäng alla");
            //Aria
            $(selector).find(".js-meeting-document-expand-link").attr("aria-expanded", "true");
            $(selector).find(".expand-box").attr("aria-hidden", "false");
        }
    }
    return meetingDocuments;

});